import React from "react";
import Header,{Footer} from "../HomePage/header";
import "./faq.css";


const FAQ = () => {
  return (
    <>
    <Header/>
    <div className="faq-container">
      
      {/* Top Banner */}
      <div className="faq-banner">
        <img
          src="/images/faq-banner.jpg"
          alt="FAQ Banner"
          className="faq-banner-img"
        />
        <div className="faq-banner-text">
          <h1>Frequently Asked Questions</h1>
          <p>You’ve got questions. We’ve got answers.</p>
        </div>
      </div>

      {/* Main Section */}
      <div className="faq-content">
        <h3 className="faq-heading">Have a question in mind?</h3>

        <div className="faq-grid">

          {/* Returns */}
          <div className="faq-column">
            <h4>Returns</h4>
            <ul>
              <li>
                I have a problem with my return <span>+</span>
              </li>
              <li>
                How refunds work? <span>+</span>
              </li>
              <li>
                Our return policy and process <span>+</span>
              </li>
              <li>
                My order was returned to sender or refused <span>+</span>
              </li>
            </ul>
          </div>

          {/* Payments */}
          <div className="faq-column">
            <h4>Payments</h4>
            <ul>
              <li>
                Most gift cards <span>+</span>
              </li>
              <li>
                Accepted payment methods <span>+</span>
              </li>
              <li>
                Discount codes <span>+</span>
              </li>
            </ul>
          </div>

          {/* Orders */}
          <div className="faq-column">
            <h4>Orders</h4>
            <ul>
              <li>
                Track my order <span>+</span>
              </li>
              <li>
                I want to edit or cancel my order <span>+</span>
              </li>
              <li>
                I have a problem with my order <span>+</span>
              </li>
            </ul>
          </div>

          {/* Shipping */}
          <div className="faq-column">
            <h4>Shipping</h4>
            <ul>
              <li>
                Shipping options, prices, and times <span>+</span>
              </li>
              <li>
                Our Shipping Policy <span>+</span>
              </li>
              <li>
                My order is stuck or not moving <span>+</span>
              </li>
            </ul>
          </div>

        </div>
      </div>

    </div>
    <Footer/>
    </>
  );
};

export default FAQ;